import axios, { AxiosError } from 'axios';
import * as Sentry from '@sentry/remix';
import { userStore } from '~/lib/stores/user';

interface ApiResponse<T> {
  message: string;
  data?: T;
}

interface ApiKeys {
  readKey: string;
  writeKey: string;
}
export interface UserData {
  email: string;
  handle: string;
  id: string;
  img_url: string;
}

export async function getToken(): Promise<ApiResponse<ApiKeys>> {
  try {
    return await Sentry.startSpan(
      {
        name: 'OauthHelper.getToken',
        op: 'OauthHelper.getToken',
      },
      async () => {
        const response = await axios.get<ApiResponse<ApiKeys>>('/api/auth');
        return response.data;
      },
    );
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fetch oAuthToken' },
      level: 'error',
    });

    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || 'Failed to fetch API keys');
    }

    throw new Error('An unexpected error occurred while fetching API keys');
  }
}

export async function createKeys(): Promise<ApiResponse<ApiKeys>> {
  try {
    return await Sentry.startSpan(
      {
        name: 'OauthHelper.createKeys',
        op: 'OauthHelper.createKeys',
      },
      async () => {
        const response = await axios.post<ApiResponse<ApiKeys>>('/api/auth');
        return response.data;
      },
    );
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to create API keys' },
      level: 'error',
    });

    if (error instanceof AxiosError) {
      console.error('API Error:', error.response?.data);
      throw new Error(error.response?.data?.message || 'Failed to create API keys');
    }

    console.error('Unexpected Error:', error);
    throw new Error('An unexpected error occurred while creating API keys');
  }
}

export type { ApiResponse, ApiKeys };
